var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "服务模式：", prop: "deliveryMethodList" } },
        [
          _c(
            "el-checkbox-group",
            {
              attrs: { disabled: _vm.isDisabled },
              model: {
                value: _vm.formValidate.deliveryMethodList,
                callback: function ($$v) {
                  _vm.$set(_vm.formValidate, "deliveryMethodList", $$v)
                },
                expression: "formValidate.deliveryMethodList",
              },
            },
            [
              _c("el-checkbox", { attrs: { label: "3" } }, [
                _vm._v("到店服务"),
              ]),
              _c("el-checkbox", { attrs: { label: "4" } }, [
                _vm._v("上门服务"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "from-tips" }, [
            _vm._v("用户购买此预约服务商品，可以选择的服务方式"),
          ]),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "剩余可约数量：", required: "" } },
        [
          _c("el-switch", {
            attrs: {
              size: "small",
              "active-value": true,
              "inactive-value": false,
              "active-text": "开启",
              "inactive-text": "关闭",
              disabled: _vm.isDisabled,
            },
            model: {
              value:
                _vm.formValidate.supplementReservation.remainingNumShouSwitch,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formValidate.supplementReservation,
                  "remainingNumShouSwitch",
                  $$v
                )
              },
              expression:
                "formValidate.supplementReservation.remainingNumShouSwitch",
            },
          }),
          _c("div", { staticClass: "from-tips" }, [
            _vm._v("关闭后，用户无法查看各时段的剩余预约数量"),
          ]),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "可约日期：", required: "" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { disabled: _vm.isDisabled },
              model: {
                value:
                  _vm.formValidate.supplementReservation.reservationDateType,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.formValidate.supplementReservation,
                    "reservationDateType",
                    $$v
                  )
                },
                expression:
                  "formValidate.supplementReservation.reservationDateType",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("每天")]),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("自定义")]),
            ],
            1
          ),
          _vm.formValidate.supplementReservation.reservationDateType === 2
            ? _c(
                "div",
                { staticClass: "flex mt10" },
                [
                  _c("el-date-picker", {
                    staticClass: "mr20",
                    staticStyle: { width: "360px" },
                    attrs: {
                      type: "daterange",
                      size: "small",
                      clearable: false,
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      disabled: _vm.isDisabled,
                    },
                    model: {
                      value: _vm.timeVal,
                      callback: function ($$v) {
                        _vm.timeVal = $$v
                      },
                      expression: "timeVal",
                    },
                  }),
                  _vm._l(_vm.week, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        class: {
                          "check-btn": true,
                          selected:
                            _vm.formValidate.supplementReservation.reservationDateWeekRangeList.includes(
                              item.id
                            ),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleWeekday(item.id)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "from-tips" }, [
            _vm._v("设置预约服务的可预约日期。"),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.formValidate.supplementReservation
                        .reservationDateType === 2,
                    expression:
                      "formValidate.supplementReservation.reservationDateType === 2",
                  },
                ],
              },
              [
                _vm._v(
                  "例如：周六、周天不选中，则在可预约日期中的周一到周五可用."
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("el-form-item", { attrs: { label: "预约日期范围：", required: "" } }, [
        _c(
          "div",
          { staticClass: "font12 color-606266" },
          [
            _vm._v(" 对用户展示 "),
            _c("el-input-number", {
              staticClass: "ml10 mr10",
              attrs: {
                size: "small",
                "controls-position": "right",
                precision: 0,
                min: 1,
                max: 60,
                disabled: _vm.isDisabled,
              },
              model: {
                value:
                  _vm.formValidate.supplementReservation
                    .reservationDateDayRange,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.formValidate.supplementReservation,
                    "reservationDateDayRange",
                    $$v
                  )
                },
                expression:
                  "formValidate.supplementReservation.reservationDateDayRange",
              },
            }),
            _vm._v(" 天内的可预约日期 "),
          ],
          1
        ),
        _c("div", { staticClass: "from-tips" }, [
          _vm._v(
            "用户端可以看到的可预约日期。示例：设置1天，则代表只可以预约当天"
          ),
        ]),
      ]),
      _c(
        "el-form-item",
        { attrs: { label: "提前预约：", required: "" } },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "quota-settings",
              model: {
                value:
                  _vm.formValidate.supplementReservation
                    .advanceReservationSwitch,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.formValidate.supplementReservation,
                    "advanceReservationSwitch",
                    $$v
                  )
                },
                expression:
                  "formValidate.supplementReservation.advanceReservationSwitch",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-item" },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: false, disabled: _vm.isDisabled } },
                    [_vm._v("无需提前预约")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-item" },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: true, disabled: _vm.isDisabled } },
                    [
                      _vm._v(" 用户要求提前 "),
                      _c("el-input-number", {
                        staticClass: "ml10 mr10",
                        attrs: {
                          min: 1,
                          max: 999,
                          precision: 0,
                          "controls-position": "right",
                          size: "small",
                          disabled: _vm.isDisabled,
                        },
                        model: {
                          value:
                            _vm.formValidate.supplementReservation
                              .advanceReservationHour,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate.supplementReservation,
                              "advanceReservationHour",
                              $$v
                            )
                          },
                          expression:
                            "formValidate.supplementReservation.advanceReservationHour",
                        },
                      }),
                      _vm._v(" 小时进行预约 "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "from-tips mt10" }, [
                _vm._v(
                  " 用户只能预约间隔时间后的时段。示例：当前10:00,设置2h，则用户只可预约12:00往后的时段 "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "取消订单：", required: "" } },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "quota-settings",
              model: {
                value: _vm.formValidate.supplementReservation.cancelOrderSwitch,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.formValidate.supplementReservation,
                    "cancelOrderSwitch",
                    $$v
                  )
                },
                expression:
                  "formValidate.supplementReservation.cancelOrderSwitch",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-item" },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: false, disabled: _vm.isDisabled } },
                    [_vm._v("不允许取消")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-item" },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: true, disabled: _vm.isDisabled } },
                    [
                      _vm._v(" 服务开始 "),
                      _c("el-input-number", {
                        staticClass: "ml10 mr10",
                        attrs: {
                          min: 1,
                          max: 999,
                          precision: 0,
                          "controls-position": "right",
                          size: "small",
                          disabled: _vm.isDisabled,
                        },
                        model: {
                          value:
                            _vm.formValidate.supplementReservation
                              .cancelOrderHour,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate.supplementReservation,
                              "cancelOrderHour",
                              $$v
                            )
                          },
                          expression:
                            "formValidate.supplementReservation.cancelOrderHour",
                        },
                      }),
                      _vm._v(" 小时之前，允许取消并自动退款 "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "from-tips mt10" }, [
                _vm._v(
                  " 设置用户最晚可以取消预约的时间。示例：设置2h，用户预约12:00-14:00，则当天10:00之前允许用户取消预约 "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "表单信息：", required: "" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { disabled: _vm.isDisabled },
              model: {
                value:
                  _vm.formValidate.supplementReservation.formDataSubmitType,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.formValidate.supplementReservation,
                    "formDataSubmitType",
                    $$v
                  )
                },
                expression:
                  "formValidate.supplementReservation.formDataSubmitType",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [
                _vm._v("每个预约提交一次"),
              ]),
              _c("el-radio", { attrs: { label: 2 } }, [
                _vm._v("每单提交一次 "),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "from-tips" }, [
            _vm._v(
              " 一次购买2件预约商品，选择每个预约提交一次则需要填写两遍关联系统表单，选择每单提交一次则只需要填写一遍关联系统表单 "
            ),
          ]),
        ],
        1
      ),
      _vm.formValidate.type === 7
        ? _c(
            "el-form-item",
            { attrs: { label: "关联表单：" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "from-ipt-width",
                  attrs: {
                    disabled: _vm.isDisabled,
                    placeholder: "请选择关联表单",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.formValidate.systemFormId,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "systemFormId", $$v)
                    },
                    expression: "formValidate.systemFormId",
                  },
                },
                _vm._l(_vm.systemFormList, function (item, index) {
                  return _c("el-option", {
                    key: index.id,
                    attrs: { value: item.id, label: item.formName },
                  })
                }),
                1
              ),
              _vm.checkPermi(["merchant:system:form:add"]) && !_vm.isDisabled
                ? _c(
                    "el-button",
                    {
                      staticClass: "ml15",
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerCreatFrom(0, "add")
                        },
                      },
                    },
                    [_vm._v("添加表单")]
                  )
                : _vm._e(),
              _vm.checkPermi(["merchant:system:form:add"]) && !_vm.isDisabled
                ? _c(
                    "el-button",
                    {
                      staticClass: "ml15",
                      attrs: { size: "small" },
                      on: { click: _vm.changeSystemFormList },
                    },
                    [_vm._v("刷新")]
                  )
                : _vm._e(),
              _c("div", { staticClass: "from-tips mb5" }, [
                _vm._v(
                  " 用户购买此商品时，必须填写关联表单中设置的字段内容才能够进行订单支付，例如：部分商品购买必须填写身份证号、预约时间等 "
                ),
              ]),
              _vm.formValidate.systemFormId
                ? _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", [
                        _c("iframe", {
                          staticStyle: { width: "350px", height: "500px" },
                          attrs: {
                            src:
                              _vm.$selfUtil.getFrontDomainUrl() +
                              "/pages/goods/systemIframe/index?id=" +
                              _vm.formValidate.systemFormId,
                            frameborder: "0",
                          },
                        }),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }